import * as yup from "yup";

export const LoginValidate = yup.object().shape({
  username: yup.string().trim().required("El username es requerido"),
  password: yup.string().trim().required("El password es requerido"),
});

export const Depreacated_ProviderValidationSchema = yup.object().shape({
  nombre: yup.string().trim().required("El nombre es requerido"),
  tel: yup.string().trim().required("El teléfono es requerido"),
  domicilio: yup.string().trim().required("El domicilio es requerido"),
  mail: yup
    .string()
    .trim()
    .email("Ingresa una dirección de correo válida")
    .required("El correo es requerido"),
  comentarios: yup.string().trim().optional(),
});

export const Depreacated_PaymentValidationSchema = yup.object().shape({
  importe: yup.number().required("El importe es requerido"),
  proveedorId: yup.number().required("El proveedor es requerido"),
  moneda: yup.string().oneOf(['U$D', '$']).required("La moneda es requerida"),
});
